const overrides = {
  development: true,
  api: {
    protocol: "http",
    hostname: "localhost:3000",
    version: "/v1",
    ttl: 8000,
    headers: { Accept: "application/vnd.api+json" }
  },
  nz_post_api: {
    protocol: "https",
    hostname: "api.nzpost.co.nz/addresschecker",
    version: "/1.0",
    ttl: 8000,
    headers: { Accept: "application/json" }
  },
  ip_geolocation_api: {
    protocol: "https",
    hostname: "geoip.1centre.com",
    ttl: 8000
  },
  mixpanel: "fd8272f1e4542cd518b97ca180dd62ba",
  churnzero: "xO67YBVbk4-f3WmogOvNavcPsFf7xW0Yy7Mr5mvtYL8",
  recaptcha_api: {
    hostname: "uat-api.cd.1centre.com/node",
    protocol: "https",
    ttl: 8000,
  },
  recaptcha_key: "6Lca1igaAAAAAPtlb8doOafzCpGDZA0lZkUjZ7Hd",
  sentry_token: "67d745e8346f43ea99d0f51f75e08c926de3b6616ef542f4961f8041c76811d0",
  sentry_release: "3c07775073f711ec944b6a86e6f34856",
  visible_reporting_phase: [1, 2],
};
module.exports = overrides;
